<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form ref="form">
        <v-row>
          <h2 class="pb-5">{{ this.parentObject.pageTitle }}</h2>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
          <v-toolbar-title class="subtitle-2">{{$t('statutoryexportcommonused.noparamter')}}</v-toolbar-title>
        </v-container>

        <v-row>
          <div class="pt-5 pl-4 pb-4">
            <v-btn color="warning" style="width: 100px" @click="backHandler">
              {{$t('button.back')}}
            </v-btn>
          </div>
          <div class="pt-5 pl-4 pb-4">
            <v-btn color="warning" style="width: 100px" @click="getHLBExportListHandler">
              {{$t('button.export')}}
            </v-btn>
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import XLSX from 'xlsx/xlsx';
import Loading from "vue-loading-overlay";
import XLSX from 'xlsx/xlsx';
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-error": ErrorDialog,
    Loading,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
      },
      //pageTitle: 'MBB-EMAS-01',

      id: this.parentObject.id,
      data: this.parentObject.data,
      jsondata: [
        {user: 'hc', name: 'Harry Cole',    phone: '1-415-2345678', gender: 'M', age: 25, birth: '1997-07-01'},
        {user: 'sm', name: 'Simon Minolta', phone: '1-123-7675682', gender: 'M', age: 20, birth: '1999-11-12'},
        {user: 'ra', name: 'Raymond Atom',  phone: '1-456-9981212', gender: 'M', age: 19, birth: '2000-06-11'},
        {user: 'ag', name: 'Mary George',   phone: '1-556-1245684', gender: 'F', age: 22, birth: '2002-08-01'},
        {user: 'kl', name: 'Kenny Linus',   phone: '1-891-2345685', gender: 'M', age: 29, birth: '1990-09-01'}
      ],
      salstatutoryother: null,
      psnstatutoryinfo: [],
      psnpayroll: [],
      titleData: this.parentObject.data.epfsubrecpy[0].payoutdesc,
      statecodeList: [
        {
            text: 'Johor',
            value: '01',
        },
        {
            text: 'Kedah',
            value: '02',
        },
        {
            text: 'Kelantan',
            value: '03',
        },
        {
            text: 'Melaka',
            value: '04',
        },
        {
            text: 'Negeri Sembilan',
            value: '05',
        },
        {
            text: 'Pahang',
            value: '06',
        },
        {
            text: 'Pulau Pinang',
            value: '07',
        },
        {
            text: 'Perak',
            value: '08',
        },
        {
            text: 'Perlis',
            value: '09',
        },
        {
            text: 'Selangor',
            value: '10',
        },
        {
            text: 'Terengganu',
            value: '11',
        },
        {
            text: 'Sabah',
            value: '12',
        },
        {
            text: 'Sarawak',
            value: '13',
        },
        {
            text: 'Wilayah Persekutuan (Kuala Lumpur)',
            value: '14',
        },
        {
            text: 'Wilayah Persekutuan (Labuan)',
            value: '15',
        },
        {
            text: 'Wilayah Persekutuan (Putrajaya)',
            value: '16',
        }
      ],
      pindicatorList: [
          {
              text: 'N',
              value: 'N',
          },
          {
              text: 'S',
              value: 'S',
          }
      ],

      companyrecnum: "",
      bankcode: "011",
      receivingbank: "",
      paymentref: "",
      paymentdesc: "",
      addr: "",
      filler: "",
      totalAmtEmployer: null,
      totalAmtMember: null,
      totalRefno: null,
      

      bodyholder: null,
      accErr: [],
      negErrMsg: [],
      salhdErr: [],
      gettotalAmt: [],
      epfdata: [],
      loading: false,

      processedCount: null,
      successCount: null,
      errCount: null,
      exCount: null,
      errMsg: "",
      isErr: false,
      isEdit: this.parentObject.isEdit,
    };
  },

  methods: {
    
    getHLBExportListHandler() {
      this.loading = true;
      const vm = this
      
      //console.log('abc')

      let dateHolder2 = this.data.year + "-" + this.pad(this.data.month, 2) + "-" + this.daysInMonth(this.data.month, this.data.year);
      let date = moment(dateHolder2).format("YYYY-MM-DD");
      
      this.$store.dispatch('get', {
          url:  `/hlbepfexport/all/${this.$store.getters.userId}`
            + "/" +  this.data.epfexprecid
            + "/" + this.data.refnum + "/" + date + "/" + date
      })
      .then(function (res) {
        vm.epfdata = res.data.rec;

         vm.exportHandler(); 

      })
      .catch(function (err) {
        vm.errMsg = err;
      });
    },
    //   const vm = this
      
    //   axios.get(`${this.$store.getters.apiURL}/hlbepfexport/all/${this.$store.getters.userId}`)
    //   .then(function (res) {

    //         let epfdataholder = res.data.rec;
    //     epfdataholder = epfdataholder.filter(e => {
    //       for (let i = 0; i < vm.data.epfsubrecpy.length; i++) {
    //         if (e.poid == vm.data.epfsubrecpy[i].poid) {
    //           return e
    //         }
    //       }
    //     })
    //     epfdataholder = epfdataholder.filter(e => e.stfamount != 0)

    //     for (let i = 0; i < epfdataholder.length; i++) {
    //       vm.epfdata.push(epfdataholder[i])
    //     }
    //   })
    //   //   let epfdataholder = res.data.rec;
    //   //   epfdataholder = epfdataholder.filter(e => e.poid == vm.data.epfsubrecpy[0].poid)
        
    //   //   epfdataholder.forEach(function (o) {
    //   //     var existing = vm.epfdata.filter(function (i) {
    //   //       return i.staffid === o.staffid;
    //   //     })[0];
    //   //     if (!existing || existing == undefined) {
    //   //       vm.epfdata.push(o);
    //   //     }
    //   //   });
    //   // })
    //   .catch(function (err) {
    //     vm.errMsg = err;
    //   });
    // },

    async getData() {
      const vm = this
      let icnoholder = ''
      let body = []
      let newepfdetail = []
      let holdpayEmployer = []
      let holdpayMember = []
      let dataholder = vm.epfdata
      let dataholderval = dataholder;//.filter(el => el.stfamount)
      let epfdetail = this.filter(dataholderval);

      this.processedCount = dataholderval.length;
      this.successCount = epfdetail.length;
      this.errCount = dataholderval.length - epfdetail.length;

      body.push(
        {
          header1: 'Employee EPF Number', 
          header2: 'Employee IC No', 
          header3: 'Employee Name', 
          header4: 'Employer Contribution', 
          header5: 'Employee Contribution',
          header6: 'Employee Internal ID', 
          header7: 'Employee Salary Amount'
        },
       );

      // let header = {
      //     "Contact Person Name": this.formData.psnname,
      //     "Contact Phone Number": this.formData.psnno,
      //     "Employer EPF Number": this.data.refnum,
      //     "Contribution Mth & Yr (MMYY)": getdate.toString(),
      //     "State Code": this.formData.statecode,
      //     "Payment Indicator": this.formData.pindicator,
      //     "Sequence Number": this.formData.seqno,
      // }

      epfdetail.forEach(function (o) {
        var existing = newepfdetail.filter(function (i) {
          return i.staffid === o.staffid;
        })[0];
        if (!existing || existing == undefined) {
          newepfdetail.push(o);
        } else {
          existing.coamount += o.coamount;
          existing.stfamount += o.stfamount;
          existing.stfepfwage += o.stfepfwage;
        }
      });

      newepfdetail.forEach(element => {
        if (element.icno != null && element.idtypeid == 1){
          icnoholder = element.icno.split("-").join("")
        }
        else{
          icnoholder = ''
        }

        let refnoh = '';
        if(element.refno){
          refnoh = String(element.refno).replace(/[-\s]/g, '');
        }
        else{
          refnoh ='';
        }

        body.push(
          {
            header1: refnoh, 
            header2: icnoholder.replace(/[-\s]/g, ''), 
            header3: element.psnname, 
            header4: element.coamount.toFixed(2),
            header5: element.stfamount.toFixed(2), 
            header6: element.staffcode,
            header7: element.stfepfwage.toFixed(2)}
        );

        // body.push({
        //   "Member EPF No": element.refno,
        //   "Employee NRIC No": icnoholder,
        //   "Employee Name": element.psnname,
        //   "Employer Contribution": element.coamount.toFixed(2),
        //   "Member Contribution": element.stfamount.toFixed(2),
        //   "Member Identifying Keys": element.staffcode,
        //   "Member Wage": element.stfepfwage.toFixed(2),
        // });

        holdpayEmployer.push(element.coamount);
        holdpayMember.push(element.stfamount);
      });
      this.bodyholder = body

      if (holdpayEmployer) {
        let totalAmtEmpHolder = holdpayEmployer.reduce(function (a, b) {return a + b}, 0);
        this.totalAmtEmployer = totalAmtEmpHolder.toFixed(2);
      }

      if (holdpayMember) {
        let totalAmtMemHolder = holdpayMember.reduce(function (a, b) {return a + b}, 0);
        this.totalAmtMember = totalAmtMemHolder.toFixed(2);
      }

      if (body.length > 0) {
      //  const csvData = this.objectToCSV(header, body);
      //  this.download(csvData, this.titleData);
        const wd =  XLSX.utils.json_to_sheet((body), { origin: 'A1', skipHeader: true});
        const wb = XLSX.utils.book_new();
        //console.log('wb', wb)
        // XLSX.utils.book_append_sheet(wb, wd,  this.titleData);  // too long , max 31 char
        XLSX.utils.book_append_sheet(wb, wd,  "HLB EPF");
        XLSX.writeFile(wb, this.titleData + '.xlsx');
      }
    },

    filter(item) {
      let checkdet = this.detailfilter(item)
      let checkactive = this.activefilter(checkdet)
      let checkpayment = this.paymentfilter(checkactive)
      return checkpayment
    },

    detailfilter(item) {
        let dateHolder = this.data.year + "-" + this.pad(this.data.month, 2) + "-" 
        + this.daysInMonth(this.data.month, this.data.year);
        let date = moment(dateHolder).format("YYYY-MM-DD");
        let dataitem = item.filter(e => e.refnum == this.data.refnum)
        dataitem = dataitem.filter(e => {
            return moment(e.startdate).format("YYYY-MM-DD") <= date && date <= moment(e.enddate).format("YYYY-MM-DD")
        })
        let noacc = item.filter((e) => !dataitem.includes(e));
        for (let i = 0; i < noacc.length; i++) {
            noacc[i].errormsg = this.$t('setupreport_exportmapping.nodetailinpersonstat');
            this.accErr.push(noacc[i]);
        }
        return dataitem
    },

    activefilter(item) {
      let data = item.filter(e => e.pystatcode == 'ACTIVE')
      let notactive = item.filter((e) => !data.includes(e));
      for (let i = 0; i < notactive.length; i++) {
        notactive[i].errormsg = this.$t('setupreport_exportmapping.paymentisnotactive');
        this.accErr.push(notactive[i]);
      }
      return data
    },

    paymentfilter(item) {
      let data = item.filter(e => {
          return e.coamount != 0 || e.stfamount != 0 && e.stfepfwage != 0 
      })
      let nopayment = item.filter((e) => !data.includes(e));
      for (let i = 0; i < nopayment.length; i++) {
        nopayment[i].errormsg = this.$t('setupreport_exportmapping.nopayment');
        this.accErr.push(nopayment[i]);
      }
      return data
    },

    objectToCSV(header, data) {
        const csvRows = []

        for (const key in header) {
            let headobj = key + ',' + header[key]
            csvRows.push(headobj) 
        }
        csvRows.push([])

        // get header
        const headers = Object.keys(data[0])
        csvRows.push(headers.join(','))

        // loop over the rows
        for (const row of data) {
            const values = headers.map(header => {
                const escaped = ("" + row[header]).replace(/"/g, '\\"')
                return `"${escaped}"`
            })
            csvRows.push(values.join(','))
        }
        return csvRows.join('\n')
    },

    download(data, title) {
      const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", title + ".csv");

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    pad(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },

    

    exportHandler() {
      if (!this.$refs.form.validate()) {
        this.isErr = true;
        this.errMsg = this.$t('vdatatable.someinfoismissing');
      } else {
        this.getData();
        let item = [];
        item.totalAmtEmployer = this.totalAmtEmployer;
        item.totalAmtMember = this.totalAmtMember;
        item.accounterr = this.accErr;
        item.successCount = this.successCount;
        item.processedCount = this.processedCount;
        item.errCount = this.errCount;
        if (!this.isErr) {
          this.$router.push({ name: "monthlyepfexportlog", params: { item } });
        }
      }
    },

    backHandler() {
      this.$router.push({ name: "monthlyepfexport" });
    },

    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
  },

  mounted() {
    //this.getHLBExportListHandler();
    },
};
</script>

<style scoped>
</style>